interface Location {
    company_id: string;
    lat: string;
    lng: string;
}

export const locations: Location[] = [
    {
        company_id: "70000001046420165",
        lat: "56.021634",
        lng: "37.472506",
    },
]
